const formatDate = (date: Date): string =>
  date.toLocaleDateString('pt-br', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

export default formatDate;
